import * as Sentry from '@sentry/nextjs';
import { ExtraErrorData } from '@sentry/integrations';
import getConfig from 'next/config';

import { shouldRepportError } from 'utils/setupSentry';

const { publicRuntimeConfig } = getConfig();

/**
 * This file configures the initialization of Sentry on the browser.
 * The config added here will be used whenever a page is visited.
 * https://docs.sentry.io/platforms/javascript/guides/nextjs/
 */
if (publicRuntimeConfig?.REACT_APP_ENV !== 'test') {
  Sentry.init({
    dsn: publicRuntimeConfig?.REACT_APP_SENTRY,
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1.0,
    environment: publicRuntimeConfig?.REACT_APP_ENV,
    debug: true,
    release: publicRuntimeConfig?.REACT_APP_VERSION_WWW,
    ignoreErrors: ['ChunkLoadError', 'TypeError: Failed to fetch'],
    integrations: [new ExtraErrorData()],
    normalizeDepth: 5,
    beforeSend(data, hint) {
      // Ignore IE browsers
      if (/(MSIE|Trident)/.test(navigator.userAgent)) {
        return null;
      }

      // returning null here avoids data to be collected by Sentry
      return shouldRepportError(data, hint) ? data : null;
    },
    beforeBreadcrumb(breadcrumb) {
      // filter out console breadcrumbs
      if (breadcrumb.category === 'console') {
        return null;
      }
      return breadcrumb;
    },
  });
}
